import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  // This is the page root: Documents/index.js wraps <DocumentTickets/> in it,
  // and DocumentTickets itself renders a fragment.
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / the file input follow the active theme.
    colorScheme: theme.palette.type,
  },
}));

export default useStyles;
